<template>
  <v-container fluid>
    <v-card>
      <v-card-text>

        <v-text-field
          v-model="search"
          placeholder="Search Name, <Account Id>_<Search Id>"
        ></v-text-field>
        <v-alert
          :value="true"
          type="warning"
          v-if="searches.length ===0 && !loading"
        >
          No Ubermetrics searches found for the given query.
        </v-alert>
      </v-card-text>
      <v-list three-line
              v-if="searches.length > 0">
        <template v-for="(item, index) in searches">
          <v-list-tile
            :key="item.Unique_Id"
            :to="{ name: 'ubermetrics_search_edit', params: { id: item.Unique_Id }}"
            avatar
            ripple
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.Name }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <v-chip color="green darken-3" text-color="white" v-if="item.Ubermetrics_Search_Status">
                  <v-avatar>
                    <v-icon>check_circle</v-icon>
                  </v-avatar>
                  Active
                </v-chip>
                <v-chip color="red darken-4" text-color="white" v-else>
                  <v-avatar>
                    <v-icon>block</v-icon>
                  </v-avatar>
                  Inactive
                </v-chip>
                <v-chip color="purple darken-3" text-color="white" v-if="item.Search_Type" class="hidden-sm-and-down">
                  {{item.Search_Type}}
                </v-chip>
                <v-chip color="blue-grey" text-color="white" class="hidden-sm-and-down">
                  <v-avatar class="blue-grey darken-2">{{item.Account_Id}}</v-avatar>
                  Account ID
                </v-chip>
                <v-chip color="blue-grey" text-color="white" class="hidden-sm-and-down">
                  <v-avatar class="blue-grey darken-2">{{item.Search_Id}}</v-avatar>
                  Search ID
                </v-chip>
                <v-chip color="orange darken-3" text-color="white" v-if="item.country_code">
                  <v-avatar>
                    <v-icon>language</v-icon>
                  </v-avatar>
                  {{item.country_code}}
                </v-chip>
              </v-list-tile-sub-title>
            </v-list-tile-content>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < searches.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import _ from 'underscore'
  import Config from '../utils/Config'
  import AmplifyStore from '../store/store'

  export default {
    data() {
      return {
        selected: null,
        info: null,
        loading: true,
        searches: [],
        search: '',
        errored: false,
        searchTimeout: null,
      }
    },
    watch: {
      search: {
        handler: _.debounce(
          function (value) {

            this.$emit('TriggerLoading', true)

            axios
              .get(`${Config.API_URL}/ubermetrics-searches?query=${value}`)
              .then(response => {
                this.searches = response.data
                this.$emit('TriggerLoading', false)
              })
              .catch(error => {
                console.error(error)
                this.errored = true
              })
          }, 500),
      },
    },
    mounted() {
      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`
      this.$emit('TriggerLoading', true)
      axios
        .get(`${Config.API_URL}/ubermetrics-searches?query=`)
        .then(response => {
          this.searches = response.data
          this.loading = false
          this.$emit('TriggerLoading', false)
        })
        .catch(error => {
          this.loading = false
          console.log(error)
          this.errored = true
        })
    },
  }
</script>
